import { Navigate, Route, Routes, useParams } from 'react-router-dom'

import { ProductionLayout } from '@/features/studio/layouts/ProductionLayout'
import { StudioShellLayout } from '@/features/studio/layouts/StudioShellLayout'
import { StudioIndexRedirect } from '@/features/studio/pages/StudioIndexRedirect'
import { InviteAcceptPage } from '@/features/studio/pages/InviteAcceptPage'
import { CreativeHubPage } from '@/features/studio/pages/creative/CreativeHubPage'
import { CreativeAssetsPage } from '@/features/studio/pages/creative/CreativeAssetsPage'
import { AssetsPage } from '@/features/studio/pages/production/AssetsPage'
import { BiblePage } from '@/features/studio/pages/production/BiblePage'
import { EpisodeShotWorkbenchPage } from '@/features/studio/pages/production/EpisodeShotWorkbenchPage'
import { CanvasBoardListPage } from '@/features/studio/pages/production/CanvasBoardListPage'
import { CanvasPage } from '@/features/studio/pages/production/CanvasPage'
import { HubPage } from '@/features/studio/pages/production/HubPage'
import { LegacyShotRedirect } from '@/features/studio/pages/production/LegacyShotRedirect'
import { ProductionOverviewPage } from '@/features/studio/pages/production/ProductionOverviewPage'
import { ReviewsPage } from '@/features/studio/pages/production/ReviewsPage'
import { ScriptEditorPage } from '@/features/studio/pages/production/ScriptEditorPage'
import { ScriptListPage } from '@/features/studio/pages/production/ScriptListPage'
import { SettingsPage } from '@/features/studio/pages/production/SettingsPage'
import { ShotsPage } from '@/features/studio/pages/production/ShotsPage'
import { TeamPage } from '@/features/studio/pages/production/TeamPage'
import { TasksPage } from '@/features/studio/pages/production/TasksPage'
import { TimelinePage } from '@/features/studio/pages/production/TimelinePage'
import { WriterScriptEditorPage } from '@/features/studio/pages/writer/WriterScriptEditorPage'
import { WriterScriptListPage } from '@/features/studio/pages/writer/WriterScriptListPage'
import { StudioComingSoonPage } from '@/features/studio/pages/StudioComingSoonPage'

function ScriptEditorRoute() {
  const { scriptId = '', episodeNo = '1' } = useParams()
  return <ScriptEditorPage key={`${scriptId}-${episodeNo}`} />
}

function WriterScriptEditorRoute() {
  const { scriptId = '', episodeNo = '1' } = useParams()
  return <WriterScriptEditorPage key={`${scriptId}-${episodeNo}`} />
}

/**
 * 创作中心路由树（lazy 入口，整域打进 studio chunk）。
 */
export default function StudioApp() {
  return (
    <Routes>
      <Route element={<StudioShellLayout />}>
        <Route index element={<StudioIndexRedirect />} />
        <Route path="productions" element={<HubPage />} />
        <Route path="productions/:productionId" element={<ProductionLayout />}>
          <Route index element={<ProductionOverviewPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="script" element={<ScriptListPage />} />
          <Route path="script/:scriptId/episodes/:episodeNo" element={<ScriptEditorRoute />} />
          <Route path="bible" element={<BiblePage />} />
          <Route path="storyboard" element={<Navigate to="shots" replace />} />
          <Route path="shots" element={<ShotsPage />} />
          <Route path="shots/:scriptId/episodes/:episodeNo" element={<EpisodeShotWorkbenchPage />} />
          <Route path="shots/:shotId" element={<LegacyShotRedirect />} />
          <Route path="reviews" element={<ReviewsPage />} />
          <Route path="tasks" element={<TasksPage />} />
          <Route path="canvas-boards" element={<CanvasBoardListPage />} />
          <Route path="assets" element={<AssetsPage />} />
          <Route path="timeline" element={<TimelinePage />} />
          <Route path="*" element={<StudioComingSoonPage mode="production" />} />
        </Route>
        <Route path="productions/:productionId/canvas" element={<CanvasPage />} />
        <Route path="creative/:workspaceId/canvas" element={<CanvasPage />} />
        <Route path="writer" element={<WriterScriptListPage />} />
        <Route path="writer/script/:scriptId/episodes/:episodeNo" element={<WriterScriptEditorRoute />} />
        <Route path="creative/assets" element={<CreativeAssetsPage />} />
        <Route path="creative" element={<CreativeHubPage />} />
        <Route path="invites/:token" element={<InviteAcceptPage />} />
        <Route path="*" element={<Navigate to="/studio" replace />} />
      </Route>
    </Routes>
  )
}
